/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 27/7/2023
 */
import BaseObject from "@shared/BaseObject.js";

export default class TimeOption extends BaseObject {

	time: number = null
	timezone: string = null
}
